import React, { useState, useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { useRentXTransferListQuery } from 'generated/graphql';
import { format, parse } from "date-fns";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles({
  tableHeadRow: {
    backgroundColor: '#ff9800',
  },
  tableHeadCell: {
    fontSize: '11px',
    padding: '5px 10px',
    fontWeight: 600,
    color: '#000',
  },
  tableBodyCell: {
    fontSize: '11px',
    padding: '5px 10px',
  },
  tableRowOdd: {
    backgroundColor: '#faf2e8',
  },
  tableRowEven: {
    backgroundColor: '#ffffff',
  },
  tableFooterRow: {
    backgroundColor: '#ff9800',
  },
});

export const RentXTransfer = () => {
  const history = useHistory();
  const { outletID }: any = useParams();
  const classes = useStyles();
  const outlet: any = JSON.parse(localStorage.getItem('Outlet')) ?? null;

  const { data, loading } = useRentXTransferListQuery({
    fetchPolicy: 'network-only',
    variables: { outletID },
  });

  const rows = data?.RentXTransferList ?? [];

  const [page, setPage] = useState(0); // 0-based for TablePagination
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const total = 
  rows.length;

  const pagedRows = useMemo(() => {
    const start = page * rowsPerPage;
    const end = start + rowsPerPage;
    return rows.slice(start, end);
  }, [
    rows
    , page, rowsPerPage]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const totalGto = rows.reduce((sum, r) => sum + Number(r.gtoAmount || 0), 0);

  return (
    <>
      {loading && <Loading />}

      <MainHeader
        onClick={() =>
          history.push({
            pathname: `/menu/outlet-app/outlet-setting/${outletID}`,
          })
        }
        mainBtn="back"
        smTitle="Outlet App"
        title={outlet?.name || 'RentX Transfer'}
        routeSegments={[
          { name: 'Outlet Settings' },
          { name: 'RentX Transfer', current: true },
        ]}
      />

      <ContentWrapper>
        <div className="card">
          <div className="card-body" style={{ padding: 0 }}>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow className={classes.tableHeadRow}>
                    <TableCell className={classes.tableHeadCell}>Business Date</TableCell>
                    <TableCell
                      className={classes.tableHeadCell}
                      align="right"
                    >
                      GTO Amount (MYR)
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      Date Time Transferred
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>
                      Transferred Status
                    </TableCell>
                    <TableCell className={classes.tableHeadCell}>Remarks</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {total === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        className={classes.tableBodyCell}
                        align="center"
                      >
                        No RentX transfer records found.
                      </TableCell>
                    </TableRow>
                  )}
                  {pagedRows.map((r, idx) => {
                    const amount = Number(r.gtoAmount || 0);
                    const isTransferred = r.transferredStatus === true;
                    const transferredLabel = isTransferred ? 'Transferred' : 'Pending';
                    const rowClass = idx % 2 === 0 ? classes.tableRowEven : classes.tableRowOdd;

                    return (
                      <TableRow key={idx} className={rowClass}>
                        <TableCell className={classes.tableBodyCell}>
                          {/* {r.businessDate} */}
                          {r.businessDate
                            ? format(new Date(r.businessDate), 'dd/MM/yyyy')
                            : '—'}
                        </TableCell>
                        <TableCell
                          className={classes.tableBodyCell}
                          align="right"
                        >
                          {amount.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </TableCell>
                        <TableCell className={classes.tableBodyCell}>
                          {/* {r.dateTimeTransferred
                            ? new Date(rW.dateTimeTransferred as any).toLocaleString()
                            : '—'} */}

                            {r.dateTimeTransferred
                              ? new Date(r.dateTimeTransferred as any)
                                  .toLocaleString('en-GB', {
                                    timeZone: 'Asia/Kuala_Lumpur', 
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    second: '2-digit',
                                    hour12: true,
                                  })
                                  .replace(',', '')
                              : '—'}
                        </TableCell>
                        <TableCell className={classes.tableBodyCell}>
                          {transferredLabel}
                        </TableCell>
                        <TableCell className={classes.tableBodyCell}>
                          <span title={r.remarks || ''}>{r.remarks || '—'}</span>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {total > 0 && (
                    <TableRow className={classes.tableFooterRow}>
                      <TableCell className={classes.tableHeadCell}>
                        Total record: {total}
                      </TableCell>
                      <TableCell
                        className={classes.tableHeadCell}
                        align="right"
                      >
                        {totalGto.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </TableCell>
                      <TableCell className={classes.tableHeadCell} />
                      <TableCell className={classes.tableHeadCell} />
                      <TableCell className={classes.tableHeadCell} />
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              {total > 0 && (
                <TablePagination
                  component="div"
                  rowsPerPageOptions={[5, 10, 20, 50]}
                  count={total}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Rows per page:"
                />
              )}
            </TableContainer>
          </div>
        </div>
      </ContentWrapper>
    </>
  );
};

